// extracted by mini-css-extract-plugin
export default {"container":"movieList_container__+SIpw"};